import React, { useRef, useState } from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'
import FacebookShare from '../data/icons/FacebookIcon.svg'
import MailShare from '../data/icons/MailIcon.svg'
import WhatsAppShare from '../data/icons/WhatsAppIcon.svg'
import BackToTop from '../data/icons/backToTop.svg'
import Share from '../data/icons/share.svg'
import CloseShareMenu from '../data/icons/closeShareMenu.svg'

const Container = styled.div`
`

const ButtonContainer = styled.div`
display:flex;
flex-direction:row;
width:120px;
margin:0 0 10px auto;
gap:12px;
& button{
    background-color:var(--tmain);
    border-radius:10px;
    border:none;
    padding:4px;
    margin:0;
    width:48px;
    height:48px;
    border:2px solid var(--tmain);
    transition:background-color .3s ease;
    & >svg{
        width:100%;
        height:100%;
        #shareIconPath{
            transition:fill .3s ease;
        }
        #backToTopIconPath{
            transition:fill .3s ease;
        }
    }
    &:hover{
        cursor:pointer;
        background-color:var(--twhite);
        & >svg{
            #shareIconPath{
                fill:var(--tmain);
            }
            #backToTopIconPath{
                fill:var(--tmain);
            }
        }
    }
}
`

const ShareMenuContainer = styled.div`
display:${props => props.issharemenuvisible==1?("initial"):("none")};
position:fixed;
width:100%;
height:auto;
top:50%;
left:50%;
transform:translate(-50%, -50%);
background-color:var(--tmain-dark);
border-radius:5px;
z-index:91;
& h2{
    font-family:Open Sans;
    font-size:20px;
    font-weight:400;
    text-align:center;
    color:var(--twhite);
}
@media(min-width:601px){
    width:600px;
    height:300px;
    & h2{
        font-size:26px;
    }
}
`

const Buttons = styled.div`
display:flex;
flex-flow:row wrap;
align-items:center;
justify-content:center;
& button{
    display:flex;
    flex-direction:column;
    align-items:center;
    border:none;
    background-color:transparent;
    color:var(--twhite);
    margin:0 10px;
    font-family:Open Sans;
    font-size:16px;
    font-weight:300;
    & svg{
        width:78px;
        height:78px;
        margin-bottom:10px;
    }
    &:hover{
        cursor:pointer;
    }
}
`

const InputField = styled.div`
position:relative;
top:0;
left:50%;
transform:translateX(-50%);
width:60%;
margin:30px 0;
& input{
    position:relative;
    border:none;
    outline:none;
    width:100%;
    font-family:Open Sans;
    font-size:16px;
    font-weight:300;
    padding:10px 14px;
    border-radius:5px;
}
& button{
    position:absolute;
    color:#3290FF;
    top:50%;
    right:5px;
    transform:translateY(-50%);
    border:none;
    background-color:var(--twhite);
    font-family:Open Sans;
    font-size:16px;
    font-weight:400;
    &:hover{
        cursor:pointer;
    }
}
`

const BackgroundDiv = styled.div`
display:${props => props.issharemenuvisible==1?("initial"):("none")};
position:fixed;
width:100%;
height:100vh;
top:0;
left:0;
background-color:rgba(0,16,37,0.6);
z-index:90;
`

const CloseButton = styled.button`
position:absolute;
top:12px;
right:12px;
background-color:transparent;
border-radius:10px;
border:none;
padding:4px;
margin:0;
width:40px;
height:40px;
& >svg{
    width:100%;
    height:100%;
}
&:hover{
    cursor:pointer;
}
`

const ButtonMenu = (props) => {

    const [isShareMenuVisible, setIsShareMenuVisible] = useState(false);
    const inputRef = useRef(null);

    const whatsappShare = () => {
        let check = false;
        (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
        
        if (check){
            window.open("whatsapp://send?text="+props.data.text+"\n"+props.data.link+".", "_blank");
        }
        else{
            window.open("https://api.whatsapp.com/send?text="+props.data.text+"\n"+props.data.link+".", "_blank");
        }
    }

    const copyToClipboard = () => {
        inputRef.current.select();
        inputRef.current.setSelectionRange(0, 99999);

        navigator.clipboard.writeText(inputRef.current.value);
    }

    const scrollToTop = () => {
        window.scrollTo({top: 0, behavior: 'smooth'})
    }

    return(
        <Container>
            <ButtonContainer>
                <button onClick={() => setIsShareMenuVisible(true)}><Share/></button>
                <button onClick={scrollToTop}><BackToTop/></button>
            </ButtonContainer>
            <ShareMenuContainer issharemenuvisible={isShareMenuVisible?(1):(0)}>
                <h2>Teilen</h2>
                <CloseButton onClick={() => setIsShareMenuVisible(false)}><CloseShareMenu/></CloseButton>
                <Buttons>
                    <button onClick={whatsappShare}>
                        <WhatsAppShare/>
                        WhatsApp
                    </button>
                    <button onClick={() => {window.open('https://www.facebook.com/sharer/sharer.php?u='+props.data.link)}}>
                        <FacebookShare/>
                        Facebook
                    </button>
                    <button onClick={() => {window.open('mailto:?subject='+props.data.subject+'&body='+props.data.text+"\n"+props.data.link+'.')}}>
                        <MailShare/>
                        Mail
                    </button>
                </Buttons>
                <InputField>
                    <input ref={inputRef} value={props.data.link}/>
                    <button onClick={copyToClipboard}>kopieren</button>
                </InputField>
            </ShareMenuContainer>
            <BackgroundDiv issharemenuvisible={isShareMenuVisible?(1):(0)}/>
        </Container>
    );
};

ButtonMenu.propTypes = {
    data: PropTypes.shape({
        subject: PropTypes.string,
        text: PropTypes.string,
        link: PropTypes.string,
    }),
}

export default ButtonMenu;